// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-container{max-width:377px}.form-wrapper{display:flex;flex-direction:column;gap:1.5rem}.form-input{width:100%;border:1px solid var(--clr-primary);border-radius:120px!important;background-color:transparent;font-weight:500;font-size:16px!important;line-height:19px!important;padding:12px!important;outline:transparent}.valid{border-color:#a1a1a1}", ""]);
// Exports
module.exports = exports;
